import type { Screen } from "../App";

/**
 * 役割と画面の対応（tmp/fable/2026-10-20-gifting-staff-access/plan.md §3-3）。
 * ここは**見た目の出し分けだけ**。API の遮断は BFF（functions/lib/session.ts requireRole）が行う。
 * 役割の語彙は functions/lib/session.ts の Role と同じ（admin / gifting）。増やすときは両方そろえる。
 */
export type Role = "admin" | "gifting";

export interface SessionUser {
  sub: string;
  role: Role;
  name: string;
}

const ALL_SCREENS: readonly Screen[] = [
  "initiatives",
  "dashboard",
  "campaigns",
  "review",
  "analytics",
  "mall-ads",
  "pl",
  "amazon",
  "line-analytics",
  "gifting",
];

export const ROLE_SCREENS: Record<Role, readonly Screen[]> = {
  admin: ALL_SCREENS,
  gifting: ["gifting"],
};

export function screensFor(role: Role): readonly Screen[] {
  return ROLE_SCREENS[role] ?? [];
}

/** 初期画面。管理者は施策（T-MK-B の既定）、ギフティング担当はギフティング */
export function defaultScreenFor(role: Role): Screen {
  return screensFor(role)[0] ?? "gifting";
}

export function isRole(value: unknown): value is Role {
  return value === "admin" || value === "gifting";
}

export const ROLE_LABEL: Record<Role, string> = {
  admin: "管理者",
  gifting: "ギフティング担当",
};
